import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, styled, Tooltip } from "@mui/material";
import ImageModal from "../../../helpers/ImageModal";
import useImageUpload from "../../../../hooks/useImageUpload";
import useInfoSnackbar from "../../../../hooks/useInfoSnackbar";
import { getImageImageEndPoint, imageUploadImage } from "../../../../api/image";
import { isValidImage } from "../../../../api/helpers";
import { CloudUploadOutlined } from "@mui/icons-material";

const StyledAvatar = styled(Avatar)`
  position: relative;
  background-color: #00000025;
  width: 256px;
  height: auto;
  border: 2px ${props => props.theme.palette.text.disabled} solid;
  overflow: hidden;

  &:hover {
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
`;

const ImageDisplay = ({
  image,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [validImage, setValidImage] = useState(false);
  const infoSnackbar = useInfoSnackbar();
  const imageUploadObj = useImageUpload();

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  useEffect(() => {
    (async () => {
      try {
        const result = await isValidImage(
          getImageImageEndPoint(image.imageEntityId, image.version));
        setValidImage(result);
      } catch (error) {
        setValidImage(false);
      }
    })();
  }, [image.imageEntityId, image.version]);

  const handleImageSave = async () => {
    if (imageUploadObj.selectedImage !== null) {
      const response = await imageUploadImage(
        imageUploadObj.selectedImage,
        image.imageEntityId,
        imageUploadObj.handleUploadProgress,
      );
      if (response.code === "SUCCESS") {
        infoSnackbar.alertSuccess(response.message);
        window.location.reload();
      } else {
        infoSnackbar.alertError("Something went wrong...");
      }
    }
    imageUploadObj.reset();
  };

  return (
    <>
      {validImage ? (<Tooltip title="View/Modify">
          <StyledAvatar
            alt={image.name}
            variant="square"
            src={getImageImageEndPoint(image.imageEntityId, image.version)}
            onClick={handleModalOpen}
          />
        </Tooltip>
      ) : (
        <Box>
          <Button
            variant="contained"
            component="label"
            startIcon={<CloudUploadOutlined/>}
            onClick={handleModalOpen}
          >
            Upload
          </Button>
        </Box>
      )}
      <ImageModal
        imageUrl={getImageImageEndPoint(image.imageEntityId, image.version)}
        modalOpen={modalOpen}
        onModalClose={handleModalClose}
        onNewImageConfirmed={handleImageSave}
        imageUploadObj={imageUploadObj}
      />
    </>
  );
};

export default ImageDisplay;
